import React from 'react';
import { Card, CardContent } from '@mui/material';

export const MainCard = ({ children, ...props }) => {
    return (
        <Card
            elevation={0}
            sx={{
                width: '100%',
                border: '1px solid #8080803b',
            }}
        >
            <CardContent {...props}>{children}</CardContent>
        </Card>
    );
};
